export const editInputBehaviour = {
  mounted() {
    this.el.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        const eventName = this.el.dataset.keydown
        this.pushEventTo(this.el, eventName, { key: e.key })
        // prevent modal from closing
        e.preventDefault()
        e.stopImmediatePropagation()
      }
    })
    // this is to ensure that the cursor is positioned at the beginning of the input
    this.el.setSelectionRange(0, 0)
    this.el.focus()
  },
}
